import {Component, Inject, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {AdminService} from "../../services/admin.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-edit-ffk-tv-dialog',
  templateUrl: './edit-ffk-tv-dialog.component.html',
  styleUrls: ['./edit-ffk-tv-dialog.component.scss']
})
export class EditFfkTvDialogComponent implements OnInit {
  videoForm: FormGroup;
  topLevelCategories: any[] = [];

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    public dialogRef: MatDialogRef<EditFfkTvDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.videoForm = this.fb.group({
      youtubeUrl: [data.video ? data.video.youtubeUrl : '', [Validators.required, this.youtubeUrlValidator.bind(this)]],
    });
  }

  ngOnInit(): void {
    this.adminService.getAllCategoriesWithTopLevel().subscribe((categories) => {
      this.topLevelCategories = categories;
    });
  }

  youtubeUrlValidator(control: AbstractControl): ValidationErrors | null {
    const url = control.value;
    if (!url) return null;

    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})$/;

    if (!youtubeRegex.test(url)) {
      return { invalidUrl: true };
    }

    return null;
  }

  onSave(): void {
    if (this.videoForm.valid) {
      let videoData = this.videoForm.value;

      this.adminService.updateVideosUrl(this.data.video.id, videoData).subscribe(() => {
        this.dialogRef.close(true);
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
